class SizeGuide extends HTMLElement {
    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this.setupEventListeners();
    }

    open(collection: string): void {
        const pageOverlay = document.querySelector<HTMLElement>('.page-overlay-sizeguide')
        setTimeout(() => {
            this.classList.add('open');
            pageOverlay?.classList.add('open')
            this.showCollection(collection)
        });
    }

    close(): void {
        const pageOverlay = document.querySelector<HTMLElement>('.page-overlay-sizeguide')
        setTimeout(() => {
            this.classList.remove('open');
            pageOverlay?.classList.remove('open')
        });
    }

    setupEventListeners(): void {
        this.initializeOpenEvent();
        this.initializeCloseEvent();
    }

    private showCollection(collection: string) {
       const tabs = this.querySelectorAll('.size-guide__tab')

       tabs.forEach((tab) => {
        if ( tab.classList.contains(collection) ) {
            tab.classList.add('show')
        } else {
            tab.classList.remove('show')
        }
       })
    }

    private initializeOpenEvent(): void {
        const sizeGuideButtons = document.querySelectorAll<HTMLButtonElement | HTMLAnchorElement>('.size-guide-open');

        if (!sizeGuideButtons) {
            console.error('The button/anchor with class size-guide-open could not be found.');
        } else {
            sizeGuideButtons.forEach((button) => {
                button.addEventListener('click', (event: Event) => {
                    event.preventDefault();
    
                    if (typeof this.open === 'function') {
                        this.open(button.dataset.collection || '');
                    } else {
                        console.error('The open method does not exist on the <side-guide> element.');
                    }
                });
            })
        }
    }

    private initializeCloseEvent(): void {
        const closeButton = this.querySelector('.size-guide__close');
        if (closeButton) {
            closeButton.addEventListener('click', () => this.close());
        }
    }
}

export default SizeGuide